import { faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

type ReloadProps = {
  onClick: () => void;
  blocked: boolean;
  color?: string;
};

const Reload = ({ onClick, blocked, color }: ReloadProps) => {
  const style = clsx(
    'fixed bottom-5 right-6 flex justify-center items-center w-16 h-16 cursor-pointer p-0 focus:outline-none z-30 bg-white shadow-md drop-shadow-md rounded-full',
    color === 'red' && 'border-2 border-red-600 text-red-600'
  );

  return (
    <button
      aria-label="Reload"
      aria-expanded={null}
      onClick={onClick}
      type="button"
      className={style}
      disabled={blocked}
    >
      <FontAwesomeIcon icon={faSync} className="text-lg" />
    </button>
  );
};

export default Reload;
